<ion-content>
  <div class="level-content">
    <!-- Back Button -->
    <ion-button 
      fill="clear" 
      class="back-button"
      (click)="goBack()">
      <ion-icon name="arrow-back" slot="icon-only"></ion-icon>
    </ion-button>

    <!-- Main Question -->
    <h1 class="level-question">
      {{ 'LEVEL.WHAT_LEVEL' | translate: {language: targetLanguageName} }}
    </h1>

    <!-- Level Selector -->
    <div class="level-selector">
      <ion-segment 
        [(ngModel)]="selectedLevel" 
        mode="ios"
        class="level-segment">
        <ion-segment-button 
          *ngFor="let level of levels" 
          [value]="level.value"
          class="level-option">
          <ion-label>{{ level.label | translate }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>

    <!-- Level Descriptions -->
    <div class="level-descriptions">
      <div *ngIf="selectedLevel === 1" class="level-description">
        {{ 'LEVEL.BEGINNER_DESC' | translate }}
      </div>
      <div *ngIf="selectedLevel === 2" class="level-description">
        {{ 'LEVEL.INTERMEDIATE_DESC' | translate }}
      </div>
      <div *ngIf="selectedLevel === 3" class="level-description">
        {{ 'LEVEL.ADVANCED_DESC' | translate }}
      </div>
    </div>

    <!-- Start Button -->
    <ion-button 
      expand="block"
      color="success"
      class="start-button"
      (click)="goToPreferences()">
      {{ 'LEVEL.CONTINUE' | translate }}
      <ion-icon name="rocket" slot="end"></ion-icon>
    </ion-button>
  </div>
</ion-content>